import { filter, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { TranslationKeysUtil } from '~shared/utils/translation-keys.util';
import { Subject } from 'rxjs';
import { APP_USER_PASSWORDLESS_SIGNUP_ROUTE, APP_USER_VALIDATE_EMAIL_ROUTE, BLOCKED_ACCOUNT_PAGE } from '~shared/constants';

const PAGE_TITLE_IDS = {
  [`/${APP_USER_PASSWORDLESS_SIGNUP_ROUTE}`]: 'passwordless-signup-title',
  [`/${APP_USER_VALIDATE_EMAIL_ROUTE}`]: 'validate-email-title',
  [`/${BLOCKED_ACCOUNT_PAGE}`]: 'blocked-title',
};

@Component({
  selector: 'app-page-title',
  template: '<h1 [attr.id]="pageID ? pageID : null" class="page-title">{{ pageTitleTranslationKey | translate }}</h1>',
  styles: [
    `
      .page-title {
        font-size: 32px !important;
        font-weight: 900 !important;
        line-height: 32px !important;
      }
    `,
  ],
})
export class PageTitleComponent implements OnDestroy {
  public pageTitleTranslationKey: string;
  public pageID: string;
  private destroy$ = new Subject<void>();

  constructor(private router: Router) {
    this.updatePageTitleTranslationKey();
    this.getPageTitleID();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.updatePageTitleTranslationKey.bind(this)();
        this.getPageTitleID.bind(this)();
      });
  }

  private updatePageTitleTranslationKey(): void {
    const pageUrl = this.router.url.split('?')[0];
    this.pageTitleTranslationKey = TranslationKeysUtil.getPageTitle(pageUrl);
  }

  getPageTitleID(): void {
    this.pageID = PAGE_TITLE_IDS[this.router.url.split('?')[0]];
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
